module.exports = __webpack_public_path__ + "static/media/chef-4.3a4b090a.jpg";